/* eslint-disable import/no-anonymous-default-export */
import { client } from 'lib/evi-api-gateway';

const resourceUrl = `${process.env.REACT_APP_API_URL_RESOURCE}/api/user/resource_log`;
const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;

export async function getUserReport(params: any) {
  return client.post({
    url: `${url}/parent_child/get_user_report`,
    form: {
      ...params
    }
  });
}

export async function getStudentResReport(params: any) {
  return client.post({
    url: `${url}/parent_child/get_task_list`,
    form: {
      ...params
    }
  });
}

export async function getSchoolResource(params: any) {
  return client.post({
    url: `${url}/school_resource/archive`,
    form: {
      ...params
    }
  });
}

export async function DeleteSchoolResource(params: any) {
  return client.post({
    url: `${url}/school_resource/delete`,
    form: {
      ...params
    }
  });
}

export async function ArchiveSchoolResource(params: any) {
  return client.post({
    url: `${url}/school_resource/unarchive`,
    form: {
      ...params
    }
  });
}

export async function getAllClassList(params: any) {
  return client.post({
    url: `${url}/school/get_all_class_list`,
    form: {
      ...params
    }
  });
}

export async function getAllClass(params: any) {
  return client.post({
    url: `${url}/parent_child/get_all_class`,
    form: {
      ...params
    }
  });
}

// add
export async function addParentChildTask(parmas: any) {
  return client.post({
    url: `${url}/main/add`,
    form: {
      ...parmas
    }
  });
}

// 詳情
export async function getFullInfo(parmas: any) {
  return client.post({
    url: `${url}/main/get_full_info`,
    form: {
      ...parmas
    }
  });
}

// update
export async function updateParentChildTask(parmas: any) {
  return client.post({
    url: `${url}/main/update`,
    form: {
      ...parmas
    }
  });
}

// user_record_comment/add
export async function addUserRecordComment(params: any) {
  return client.post({
    url: `${url}/user_record_comment/add`,
    form: {
      ...params
    }
  });
}

//檢視學生班級
export async function getReportClass(parmas: any) {
  return client.post({
    url: `${url}/parent_child/get_report_class`,
    form: {
      ...parmas
    }
  });
}

// 催促提交
export async function sendNotification(params: any) {
  return client.post({
    url: `${resourceUrl}/send_notification`,
    form: {
      ...params
    }
  });
}

// 删除
export async function deleteFile(params: any) {
  return client.post({
    url: `${url}/user_record_comment/delete_file`,
    form: {
      ...params
    }
  });
}

//檢視學生状态數據
export async function getUserReportCount(params: any) {
  return client.post({
    url: `${url}/parent_child/get_user_report_count`,
    form: {
      ...params
    }
  });
}

// 批量催促
export async function batchNotification(params: any) {
  return client.post({
    url: `${url}/parent_child/batch_notification`,
    form: {
      ...params
    }
  });
}

// 批量評審
export async function batchAdd(params: any) {
  return client.post({
    url: `${url}/user_record_comment/batch_add`,
    form: {
      ...params
    }
  });
}

// 從貼堂區移除
export async function batchDeleteHighlight(params: any) {
  return client.post({
    url: `${url}/parent_child/batch_delete_highlight`,
    form: {
      ...params
    }
  });
}

// 移除批改結果
export async function batchDeleteComment(params: any) {
  return client.post({
    url: `${url}/parent_child/batch_delete_comment`,
    form: {
      ...params
    }
  });
}

//發佈至貼堂區
export async function batchAddHighlight(params: any) {
  return client.post({
    url: `${url}/parent_child/batch_add_highlight`,
    form: {
      ...params
    }
  });
}

// 亲子任务数字
export async function getStudentReportCount(params: any) {
  return client.post({
    url: `${url}/parent_child/get_task_tab_count`,
    form: {
      ...params
    }
  });
}

export default {
  getUserReport,
  getStudentResReport,
  getSchoolResource,
  DeleteSchoolResource,
  ArchiveSchoolResource,
  getAllClassList,
  addParentChildTask,
  getFullInfo,
  updateParentChildTask,
  addUserRecordComment,
  getReportClass,
  sendNotification,
  deleteFile,
  getUserReportCount,
  batchNotification,
  batchAdd,
  batchDeleteHighlight,
  batchDeleteComment,
  batchAddHighlight,
  getStudentReportCount
};
